module.exports = __webpack_public_path__ + "img/medal-bronze.6b08cb96.svg";